import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  CircularProgress,
  Container,
  Button,
} from '@mui/material';
import { Add as AddIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import api from '../utils/api';

const AllAmplifiedEvents = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/schools/amplified-events');
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching national events:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const renderEventItem = (item) => (
    <Grid item xs={12} sm={6} md={4} key={item._id}>
      <Card
        sx={{
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          borderRadius: 2,
          bgcolor: '#fff',
        }}
      >
        <CardActionArea
          onClick={() => navigate('/amplified-event-details', { state: { event: item } })}
        >
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', flex: 1 }}>
                {item.eventName}
              </Typography>
              <ChevronRightIcon sx={{ color: '#6200ee' }} />
            </Box>
            <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
              {new Date(item.dateTime).toLocaleDateString()} • {item.venue}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              Organized by: {item.organizer}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          bgcolor: '#f8f9fa',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#6200ee' }} />
        <Typography variant="h6" sx={{ mt: 3, color: '#2c3e50' }}>
          Loading events...
        </Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          National Events
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/publish-amplified-event')}
          sx={{
            bgcolor: '#6200ee',
            '&:hover': { bgcolor: '#7f39fb' },
            borderRadius: 2,
            mb: 4,
            px: 3,
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 'bold',
          }}
        >
          Publish National Event
        </Button>
      </motion.div>
      {events.length === 0 ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Typography sx={{ textAlign: 'center', color: '#666', mt: 5 }}>
            No national events published yet
          </Typography>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Grid container spacing={3}>
            {events.map((item) => renderEventItem(item))}
          </Grid>
        </motion.div>
      )}
    </Container>
  );
};

export default AllAmplifiedEvents;